import Vue from 'vue'

const enrollmentManagement = {
    state: {
        enterDetailsObj: {},
        dialogEnterDetails: false,
        studentEnrollDetailsObj: {},
        studentDetailsEntryDialog: false,
        channelList: [],
        studentId: 0
    },
    mutations: {
        GET_ENROLLMENT_DETAIL_OBJ: (state, obj) => {
            state.enterDetailsObj = obj;
        },
        CHANGE_DETAILS_ENTRY_DIALOG: (state, status) => {
            state.studentDetailsEntryDialog = status;
        },
        CHANGE_DETAIL_DIALOG: (state, status) => {
            state.dialogEnterDetails = status;
        },
        GET_STUDENT_ENROLL_DETAIL: (state, obj) => {
            state.studentEnrollDetailsObj = obj
        },
        SET_CHANNEL_LIST: (state, arr) => {
            state.channelList = arr;
        },
        SET_STUDENTID: (state, id) => {
            state.studentId = id
        }
    },
    actions: {
        GET_INTERVIEW_DATA(content, obj) {
            if(obj.id!=0){
                obj.that.$post('/recruit/getRecruitStudentById', {id: obj.id}).then((response) => {         
                  // 预约面谈 
                  content.commit("GET_STUDENT_ENROLL_DETAIL", response.data);
                  content.commit("GET_ENROLLMENT_DETAIL_OBJ", obj.obj);
                  content.commit("CHANGE_DETAIL_DIALOG", true);
                }).catch(function (error) {
                    console.log(error);
                });
              } else {
                content.commit("GET_ENROLLMENT_DETAIL_OBJ", obj.obj);
                content.commit("CHANGE_DETAIL_DIALOG", true);
              }
            // content.commit('GET_STUDENT_ENROLL_DETAIL')
        }
    }
  }
  
  export default enrollmentManagement


// WEBPACK FOOTER //
// ./src/store/modules/enrollAndRecruit/enrollmentManagement.js